/**
 * Whether the console should offer Refund for a payment.
 *
 * One rule for the detail page and the list, which held two copies of it and had already drifted on
 * which field they read. It only decides whether to SHOW the action — the authority is the refund
 * preview (`canRefund` / `refusalReason`), which also covers what this cannot see, such as a
 * balance settlement funded entirely by sign-up bonus.
 *
 * Only an order payment settled with real money qualifies:
 * - a top-up's money is already the customer's to spend, so a deposit that should not stand is
 *   refused with Reject before it reaches the wallet. Matched on the order's TYPE, never on the
 *   absence of an order — deposits raise a `BalanceTopUp` order of their own now, and `hasOrder`
 *   stays only for the deposits opened before they did;
 * - a trial carries an order and is born Completed, so `paymentMethod` is the only axis that marks
 *   it; no cash was ever collected for one.
 *
 * A Balance settlement IS offered: the preview reports the cash the ledger actually debited, which
 * can be less than the payment's own amount.
 */
export function isRefundCandidate(payment: {
  status?: string;
  paymentMethod?: string;
  orderType?: string | null;
  hasOrder: boolean;
}): boolean {
  return (
    payment.status === "Completed" &&
    payment.hasOrder &&
    payment.orderType !== "BalanceTopUp" &&
    payment.paymentMethod !== "Trial"
  );
}
